import * as types from './mutation-types'

const mutations = {
  [types.SET_USER_INFO] (state, userInfo) {
    state.userInfo = userInfo
  },
  [types.SET_PERMISSIONS] (state, permissions) {
    state.permissions = permissions
  },
  changeLoginDialog (state,payload){
    state.showLoginDialog = payload.isShow;
  },
  changeRefreshHeader (state,payload){
    state.refreshHeader = payload.headerRefresh;
  },
  changeisClosePage (state,payload){
    state.isClosePage = payload.ClosePage;
  },
  changeIsLogOut (state,payload){
    state.isLogOut = payload.isLogOut;
  },
  judgeUserStatusChange(state,payload){
    state.userStatusChange = payload.flag;
  },
  baseUrl(state, baseUrl){
  	state.baseUrl = baseUrl;
  },
  appName(state, appName){
  	state.appName = appName;
  },
  appSecret(state, appSecret){
  	state.appSecret = appSecret;
  },
  cystorageUrl(state, cystorageUrl){
  	state.cystorageUrl = cystorageUrl;
  },
  headerActive(state,headerActive){
    state.headerActive = headerActive;
  },
  isLeavePage(state, isLeavePage){
    state.isLeavePage = isLeavePage
  },
  [types.PLAY_MEDIA] (state, data) {
    state.media = Object.assign(state.media, data)
  }

}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js